import React, { useContext } from 'react';
import styled from 'styled-components';
import AlertModal from '../../components/modal/AlertModal';
import { useNavigate } from 'react-router-dom';
import { TimerComponent, sendInterval } from '../../components/Timer';
import LoginController from '../../controller/LoginController';

interface LoginFindMainProps {
  setFindIdSuccess: React.Dispatch<React.SetStateAction<boolean>>;
  setFindPasswordSuccess: React.Dispatch<React.SetStateAction<boolean>>;
  // setTitle: React.Dispatch<React.SetStateAction<string>>;
  typeForgot: string;
  moveLoginPage: () => void;
  setFindId: React.Dispatch<React.SetStateAction<string[]>>;
  setAuthenticationKey: React.Dispatch<React.SetStateAction<number>>;
  authenticationKey: number;
  setStoreId: React.Dispatch<React.SetStateAction<number>>;
}
let timer: any = null;
export const LoginAccountFind = ({
  setFindIdSuccess,
  setFindPasswordSuccess,
  // setTitle,
  typeForgot,
  moveLoginPage,
  setFindId,
  setAuthenticationKey,
  authenticationKey,
  setStoreId,
}: LoginFindMainProps) => {
  const navigate = useNavigate();
  const [currentTab, setCurrentTab] = React.useState<number>(0);
  const [name, setName] = React.useState<string>('');
  const [phoneNumber, setPhoneNumber] = React.useState<string>('');
  const [accountId, setAccountId] = React.useState<string>('');
  const [nameErrorText, setNameErrorText] = React.useState<string>('');
  const [phoneErrorText, setPhoneErrorText] = React.useState<string>('');
  const [idErrorText, setIdErrorText] = React.useState<string>('');
  const [authenticationErrorText, setAuthenticationErrorText] = React.useState<string>('');
  const [authenticationNumber, setAuthenticationNumber] = React.useState<string>('');
  const [authenticationErrorModal, setAuthenticationErrorModal] = React.useState<boolean>(false);
  const [sendMessage, setSendMessage] = React.useState<boolean>(false);
  const [countError, setCountError] = React.useState<boolean>(false);
  const [countdown, setCountdown] = React.useState<number>(0);
  const [timerRunning, setTimerRunning] = React.useState<boolean>(false);

  const pattern = /[가-힣]*[ㄱ-ㅎㅏ-ㅣ]+[가-힣]*/;

  // inputonChange
  const handleInputChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    nameErrorText: string,
    phoneErrorText: string,
  ) => {
    const value = event.target.value;
    const regExp = /[0-9 \{\}\[\]\/?.,;:|\)*~`!^\-_+┼<>@\#$%&\'\"\\\(\=]/gi;
    const numericValue = value.replace(/\D/g, '');
    if (event.target.id === 'name') {
      setName(value);
      if (regExp.test(value)) {
        setNameErrorText(nameErrorText);
      } else {
        setNameErrorText('');
      }
    } else if (event.target.id === 'accountId') {
      setAccountId(value);
      if (accountId.length > 0) {
        setIdErrorText('');
      }
    } else if (event.target.id === 'phoneNumber') {
      setPhoneNumber(numericValue);
      if (numericValue.length > 11) {
        setPhoneErrorText('올바른 휴대폰 번호를 입력해주세요.');
      } else {
        setPhoneErrorText('');
      }
    } else if (event.target.id === 'authenticationNumber') {
      setAuthenticationNumber(numericValue);
    }
  };

  // 인증번호 발송
  const sendAuthenticationNumber = () => {
    if (menuTab[currentTab].tabStatus === 'id' && name === '') {
      setNameErrorText('대표자명을 입력해 주세요');
    }
    if (pattern.test(name)) {
      setNameErrorText('특수문자, 숫자가 없는 올바른 이름만 입력해주세요.');
    }
    if (menuTab[currentTab].tabStatus === 'password' && accountId === '') {
      setIdErrorText('아이디를 입력해 주세요');
    }
    if (phoneNumber === '' || phoneNumber.length < 10 || phoneNumber.length > 11) {
      setPhoneErrorText('올바른 휴대폰 번호를 입력해주세요.');
    } else {
      if (menuTab[currentTab].tabStatus === 'id') {
        findForgetIdAuth();
        setTimerRunning(true);
      } else if (menuTab[currentTab].tabStatus === 'password') {
        findForgetPwdAuth();
        setTimerRunning(true);
      }
    }
  };

  // 인증번호 재전송
  const reSendAuthenticationNumber = () => {
    if (menuTab[currentTab].tabStatus === 'id' && name === '') {
      setNameErrorText('대표자명을 입력해 주세요');
    }
    if (pattern.test(name)) {
      setNameErrorText('특수문자, 숫자가 없는 올바른 이름만 입력해주세요.');
    } else if (menuTab[currentTab].tabStatus === 'password' && accountId === '') {
      setIdErrorText('아이디를 입력해 주세요');
    } else if (phoneNumber === '' || phoneNumber.length < 10 || phoneNumber.length > 11) {
      setPhoneErrorText('올바른 휴대폰 번호를 입력해주세요.');
    } else {
      if (timer === null) {
        setAuthenticationErrorText('');
        setSendMessage(true);

        timer = sendInterval(180, setCountdown, () => {
          setAuthenticationErrorText('입력시간이 초과! 인증번호 재전송을 눌러주세요.');

          setTimerRunning(false);
          timer = null;
        });

        if (menuTab[currentTab].tabStatus === 'id') {
          findForgetIdAuth();
          setTimerRunning(true);
        } else if (menuTab[currentTab].tabStatus === 'password') {
          findForgetPwdAuth();
          setTimerRunning(true);
        }
      } else {
        setAuthenticationErrorText('인증번호가 이미 발송되었습니다.');
      }
    }
  };

  // 인증번호 확인
  const checkAuthenticationNumber = () => {
    const isValid = checkAuthenticationResult();
    if (isValid) {
      authNumVerify();
    } else {
      setAuthenticationErrorText('인증번호를 확인해주세요');
    }
  };
  const checkAuthenticationResult = () => {
    let isValid = true;

    if (menuTab[currentTab].tabStatus === 'id') {
      if (name === '') {
        setNameErrorText('대표자명을 입력해 주세요');
        isValid = false;
      } else if (pattern.test(name)) {
        setNameErrorText('특수문자, 숫자가 없는 올바른 이름만 입력해주세요.');
        isValid = false;
      }
    } else if (menuTab[currentTab].tabStatus === 'password') {
      if (accountId === '') {
        setIdErrorText('아이디를 입력해 주세요');
        isValid = false;
      }
    }

    if (phoneNumber === '' || phoneNumber.length < 10 || phoneNumber.length > 11) {
      setPhoneErrorText('올바른 휴대폰 번호를 입력해주세요.');
      isValid = false;
    }

    return isValid;
  };

  //모달닫기
  const handleCloseModal = () => {
    setAuthenticationErrorModal(false);
  };

  // Tab
  const menuTab = [
    { name: '아이디 찾기', tabStatus: 'id' },
    { name: '비밀번호 찾기', tabStatus: 'password' },
  ];
  const selectMenuHandler = (index: number) => {
    setCurrentTab(index);
    clearInterval(timer);
    setAuthenticationErrorText('');

    if (index === 0) {
      navigate('/loginIdForget');
    } else {
      navigate('/loginPasswordForget');
    }
    // 초기화
    setName('');
    setPhoneNumber('');
    setAccountId('');
    setNameErrorText('');
    setPhoneErrorText('');
    setIdErrorText('');
    setSendMessage(false);
    setCountdown(0);
    setCountError(false);
    setAuthenticationNumber('');
  };
  React.useEffect(() => {
    setFindId([]);
    if (typeForgot === 'id') {
      setCurrentTab(0);
    } else if (typeForgot === 'password') {
      setCurrentTab(1);
    }
  }, []);

  // api_아이디찾기
  const findForgetIdAuth = async () => {
    let oData: any = {
      store_type: 1,
      full_name: name,
      phone_number: phoneNumber,
    };

    try {
      const oResp = await LoginController.findForgetIdAuth(oData);
      let oResponse = oResp?.data;

      if (oResponse.ok === true && oResponse !== undefined) {
        setSendMessage(true);
        clearInterval(timer);
        setTimerRunning(true);
        setAuthenticationKey(oResponse.data.key);
        timer = sendInterval(180, setCountdown, () => {
          setAuthenticationErrorText('입력시간이 초과! 인증번호 재전송을 눌러주세요.');
          timer = null;
        });
      } else {
        setNameErrorText('입력하신 정보로 등록된 계정을 찾을 수 없습니다');
        setPhoneErrorText('입력하신 정보로 등록된 계정을 찾을 수 없습니다');
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  // api_비밀번호찾기
  const findForgetPwdAuth = async () => {
    let oData: any = {
      store_type: 1,
      email: accountId,
      phone_number: phoneNumber,
    };

    try {
      const oResp = await LoginController.findForgetPwdAuth(oData);
      let oResponse = oResp?.data;

      if (oResponse.ok === true && oResponse.data.success) {
        setSendMessage(true);
        clearInterval(timer);
        setTimerRunning(true);
        setAuthenticationKey(oResponse.data.key);
        setStoreId(oResponse.data.store_id);
        timer = sendInterval(180, setCountdown, () => {
          setAuthenticationErrorText('입력시간이 초과! 인증번호 재전송을 눌러주세요.');
          timer = null;
        });
      } else {
        setNameErrorText('올바른 아이디를 입력해 주세요.');
        setPhoneErrorText(oResponse.data.message);
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };
  // api_아이디/비밀번호_카카오톡 인증번호
  const authNumVerify = async () => {
    let oData: any = {
      store_type: 1,
      key: authenticationKey,
      auth_code: authenticationNumber,
    };
    let path = '';
    if (menuTab[currentTab].tabStatus === 'id') {
      path = 'findIdAuthNumVerify';
    } else if (menuTab[currentTab].tabStatus === 'password') {
      path = 'pwAuthNumVerify';
    }
    try {
      const oResp = await LoginController.authNumVerify(oData, path);
      let oResponse = oResp.data;
      if (oResponse.ok === true && oResponse.data.success === true) {
        if (menuTab[currentTab].tabStatus === 'id') {
          // 아이디 찾기 결과
          setFindIdSuccess(true);
          setFindId([...oResponse.data.user]);
        } else if (menuTab[currentTab].tabStatus === 'password') {
          // setTitle('비밀번호 변경');
          setFindPasswordSuccess(true);
          setFindId([accountId]);
        }
      } else if (oResponse.data.is_matched === false || oResponse.ok === false) {
        setAuthenticationErrorModal(true);
        setAuthenticationErrorText('인증번호를 확인해주세요');
      } else {
        setAuthenticationErrorModal(true);
        setAuthenticationErrorText('인증번호를 확인해주세요');
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  return (
    <Style>
      <div className="findWrap">
        <div className="findContent">
          <img src={`${process.env.PUBLIC_URL}/svg/ic_forget.svg`} alt="찾기 아이콘" />
          <ul className="tab">
            {menuTab.map((el, index) => (
              <li onClick={() => selectMenuHandler(index)} key={index}>
                <p>{el.name}</p>
                <div
                  className={
                    index === currentTab ? 'tabline tabmenuFocused' : 'tabline tabmenu'
                  }></div>
              </li>
            ))}
          </ul>
          {menuTab[currentTab].tabStatus === 'id' && (
            <div>
              <div className="loginForm">
                <input
                  type="text"
                  id="name"
                  value={name}
                  onChange={(e) =>
                    handleInputChange(e, '특수문자나 숫자가 없는 올바른 이름만 입력해주세요.', '')
                  }
                  placeholder="대표자명을 입력해 주세요"
                  style={{ border: nameErrorText !== '' ? '1px solid #FDA29B' : '' }}
                />
              </div>
              <p className="errorMessage">{nameErrorText}</p>
            </div>
          )}
          {menuTab[currentTab].tabStatus === 'password' && (
            <div>
              <div className="loginForm">
                <input
                  type="text"
                  id="accountId"
                  value={accountId}
                  onChange={(e) =>
                    handleInputChange(e, '특수문자나 숫자가 없는 올바른 이름만 입력해주세요.', '')
                  }
                  placeholder="아이디를 입력해 주세요"
                  style={{ border: idErrorText !== '' ? '1px solid #FDA29B' : '' }}
                />
              </div>
              <p className="errorMessage">{idErrorText}</p>
            </div>
          )}
          <div className="loginForm">
            <input
              type="text"
              id="phoneNumber"
              value={phoneNumber}
              onChange={(e) => handleInputChange(e, '올바른 휴대폰 번호를 입력해주세요.', '')}
              inputMode="numeric"
              pattern="[0-9]*"
              placeholder="- 없이 휴대폰 번호를 입력해주세요"
              style={{ border: phoneErrorText !== '' ? '1px solid #FDA29B' : '' }}
            />
          </div>
          <p className="errorMessage">{phoneErrorText}</p>
          {sendMessage && (
            <div>
              <div className="loginForm">
                <div className="authenticationForm">
                  <input
                    type="text"
                    id="authenticationNumber"
                    value={authenticationNumber}
                    inputMode="numeric"
                    pattern="[0-9]*"
                    onChange={(event) => handleInputChange(event, '', '')}
                    placeholder="발송된 인증번호를 입력해주세요"
                    style={{
                      width: '100%',
                      border: authenticationErrorText !== '' ? '1px solid red' : '',
                    }}
                  />
                  <div className="right">
                    <div className="timer">
                      <TimerComponent countdown={countdown} />
                    </div>
                    <button className="retryNumber" onClick={reSendAuthenticationNumber}>
                      재전송
                    </button>
                  </div>
                </div>
              </div>
              <p className="errorMessage">{authenticationErrorText}</p>
              <p className="noticeMessage">
                인증번호는 통신사에 따라 지연될 수 있습니다. 도착하지 않으면 재전송 버튼을
                눌러주세요.
              </p>
            </div>
          )}
          {sendMessage === false ? (
            <button className="authenticationNumber" onClick={sendAuthenticationNumber}>
              <p>인증번호 받기</p>
            </button>
          ) : (
            <button className="checkAuthenticationNumber" onClick={checkAuthenticationNumber}>
              <p>인증번호 확인</p>
            </button>
          )}
        </div>
      </div>
      <button onClick={moveLoginPage} className="backPageButton">
        <p>로그인 화면으로</p>
        <img src={`${process.env.PUBLIC_URL}/svg/ic_arrow_right_grey_bold.svg`} alt="화살표" />
      </button>
      <AlertModal
        isOpen={authenticationErrorModal}
        onCancel={handleCloseModal}
        title={`인증이 완료되지 않았어요`}
        content={`입력한 정보를 다시 확인해주시고,\n인증번호가 도착하지 않으면 ‘재전송’을 눌러주세요.`}
        onCloseText={'확인'}
      />
    </Style>
  );
};

export const Style = styled.div`
  /* findContent */
  .findContent {
    img {
      display: flex;
      margin: 0 auto;
    }
  }
  /* tab */
  .tab {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0;
    margin-bottom: 34px;
    cursor: pointer;

    li {
      flex: 1;
      text-align: center;
    }
    p {
      padding: 12px 0;
      font-size: 18px;
      font-weight: 600;
      color: #a7a7a7;
    }
    .tabline {
      height: 4px;
      border-radius: 10px;
      background: #e5e5e5;
      margin: 0 -1px;
    }
    .tabmenuFocused {
      margin: 0 1px;
      background: #4dd2ae;
    }
  }

  /* inputStyle */
  .loginForm {
    display: flex;
    flex-direction: column;
    margin-top: 16px;

    label {
      margin-top: 12px;
      font-size: 16px;
      font-weight: 500;
      color: #a7a7a7;
    }
    input {
      padding: 12px 22px;
      border: 1px solid #cecece;
      border-radius: 10px;
      outline: none;
    }
  }

  /* errorMessage */
  .noticeMessage,
  .errorMessage {
    width: 100%;
    margin: 2px 0 6px 0;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    color: #a7a7a7;

    button {
      font-weight: 600;
      text-decoration: underline;
      text-underline-offset: 4px;
      background: none;
      outline: none;
      border: none;
      color: #4f5459;
      font-size: 14px;
      font-weight: 600;
    }
  }
  .errorMessage {
    color: #f04438;
    font-size: 14px;
    font-weight: 500;
  }
  .errorMessage:nth-child(6) {
    margin-bottom: 12px;
  }

  /* 인증번호받기 버튼 */
  .authenticationNumber,
  .checkAuthenticationNumber {
    width: 100%;
    margin: 28px 0 50px 0;
    background: #4dd2ae;
    border-radius: 8px;
    border: none;
    outline: none;

    p {
      padding: 11px 0;
      font-size: 20px;
      font-weight: 600;
      color: #ffffff;
    }
  }

  /* 인증번호 */
  .authenticationForm {
    position: relative;

    .right {
      position: absolute;
      top: 0;
      right: 0;
      display: flex;
      align-items: center;
      gap: 20px;
    }
    .timer {
      p {
        margin: 0;
        font-size: 12px;
        font-weight: 500;
        color: #f04438;
      }
    }
    .retryNumber {
      padding: 11px 21px;
      border: 2px solid #4dd2ae;
      border-radius: 10px;
      color: #4dd2ae;
    }
  }

  .backPageButton {
    margin-top: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    background: none;
  }
`;
